import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  REGISTRATION_AFFILIATE_ROUTE_NAME,
  REGISTRATION_CONFIRMATION_ROUTE_NAME,
  REGISTRATION_DONE_ROUTE_NAME,
  REGISTRATION_PERMISSIONS,
  REGISTRATION_ROUTE_NAME,
  TRANSLATION_GROUP_REGISTRATION,
} from './constants';
import { getTranslationKeys } from './translations';

export class RegistrationModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAnonymousRoute({
      name: REGISTRATION_ROUTE_NAME,
      path: '/registration',
      component: () => import('./pages/RegistrationPage/RegistrationPage.vue'),
      permission: REGISTRATION_PERMISSIONS.REGISTER,
    });

    router.addAnonymousRoute({
      name: REGISTRATION_CONFIRMATION_ROUTE_NAME,
      path: '/registration/confirmation/:token?',
      component: () => import('./pages/RegistrationConfirmationPage/RegistrationConfirmationPage.vue'),
      permission: REGISTRATION_PERMISSIONS.REGISTER,
    });

    router.addAnonymousRoute({
      name: REGISTRATION_DONE_ROUTE_NAME,
      path: '/registration/done',
      component: () => import('./pages/RegistrationDonePage/RegistrationDonePage.vue'),
      permission: REGISTRATION_PERMISSIONS.REGISTER,
    });

    router.addAnonymousRoute({
      name: REGISTRATION_AFFILIATE_ROUTE_NAME,
      path: '/affiliate_ref/:token',
      component: () => import('./pages/RegistrationAffiliateReferralPage/RegistrationAffiliateReferralPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_REGISTRATION, getTranslationKeys);
  }
}
